/**
 * Creative Analysis API client
 * Fetches performance, fatigue, insight, opportunities, and next-steps reports.
 * Reports are cached in DynamoDB — pass regenerate=true to force a fresh AI analysis.
 */

import apiClient from '@/shared/lib/api'
import type {
  PerformanceReportResponse,
  FatigueReportResponse,
  CreativeInsightResponse,
  AdOpportunitiesResponse,
  NextStepsResponse,
} from './types'

export const analysisApi = {
  async getPerformanceReport(
    startDate: string,
    endDate: string,
    regenerate = false
  ): Promise<PerformanceReportResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate }
    if (regenerate) params.regenerate = 'true'
    const response = await apiClient.get<PerformanceReportResponse>('/creatives/report/performance', { params })
    return response.data
  },

  async getFatigueReport(
    startDate: string,
    endDate: string,
    regenerate = false
  ): Promise<FatigueReportResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate }
    if (regenerate) params.regenerate = 'true'
    const response = await apiClient.get<FatigueReportResponse>('/creatives/report/fatigue', { params })
    return response.data
  },

  async getInsightReport(
    startDate: string,
    endDate: string,
    regenerate = false
  ): Promise<CreativeInsightResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate }
    if (regenerate) params.regenerate = 'true'
    const response = await apiClient.get<CreativeInsightResponse>('/creatives/report/insight', { params })
    return response.data
  },

  async getOpportunitiesReport(
    startDate: string,
    endDate: string,
    regenerate = false
  ): Promise<AdOpportunitiesResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate }
    if (regenerate) params.regenerate = 'true'
    const response = await apiClient.get<AdOpportunitiesResponse>('/creatives/report/opportunities', { params })
    return response.data
  },

  async getNextStepsReport(
    startDate: string,
    endDate: string,
    regenerate = false
  ): Promise<NextStepsResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate }
    if (regenerate) params.regenerate = 'true'
    const response = await apiClient.get<NextStepsResponse>('/creatives/report/next-steps', { params })
    return response.data
  },
}
